import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';
import './modules/register-service-worker';
import GmtEventPusher from './gtm-event-pusher'; //to-do: add npm version
import accessoryAutocomplete from './modules/accessory-autocomplete';

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();
GmtEventPusher.init();

if(document.querySelector('[data-toggle-element]')) {
  import('./modules/simple-toggler').then(mod => new mod.SimpleToggler());
}

const formElement = document.querySelector('form');
if(formElement) {

  import('./modules/multiselect').then(multiselect => multiselect.default.init());

  const vehicleSearchElement = document.getElementById('vehicle-search');
  if(vehicleSearchElement) {
    import('./modules/vehicle-search').then((vehicleSearch) => vehicleSearch.default.init());
    import('./modules/analytics').then(analytics => analytics.default.vehicleSearchAnalytics());

    import('./modules/number-min-max').then((input) => {
      input.default.init();
    });

    import('./modules/accessory-autocomplete').then(accessoryAutocomplete => accessoryAutocomplete.default.init());
  }

  const selectFilters = document.querySelector('.js-filter-models');
  if(selectFilters){
    import('./modules/filter-select').then(fs => fs.default.init());
  }

  //init number range
  import('./modules/number-range').then((range) => {
    range.default.init();
  });

  //init stage forms
  import('./modules/stage-forms').then((stageForms)=> {
    stageForms.default.init();
  });

  import('./modules/file-upload').then(FileUploadUI => FileUploadUI.init());

  const sellCarForm = document.querySelector('.form--sell-your-vehicle-campaign');
  if(sellCarForm) {
    import('./modules/analytics').then(analytics => analytics.default.sellYourCarFormAnalytics());
  }
}

const licenseInput = document.querySelector('.license-input');
if(licenseInput) {
  import('./modules/license-input').then(module => module.default.init());
}

const accordionElement = document.querySelector('dl.accordion');
if(accordionElement) {
  import('./modules/accordions').then(Accordions => Accordions.init());
}

const heroVehicleSearchElement = document.querySelector('.hero-vehicle-search');
if(heroVehicleSearchElement) {
  import('./modules/hero-vehicle-search').then((heroVehicleSearch) => heroVehicleSearch.default.init());
}

const cardCarouselElement = document.querySelector('.card-carousel');
if(cardCarouselElement) {
  import('./modules/card-carousel').then((cardCarousel) => cardCarousel.init());
}

const vehicleImageCarousel = document.querySelector('.vehicle-image-carousel');
if(vehicleImageCarousel) {
  import('./modules/vehicle-image-carousel').then((vehicleImageCarousel) => vehicleImageCarousel.init());
}

const vehicleSearchLiftCarouselElement = document.querySelector('.vehicle-search-lifts');
if(vehicleSearchLiftCarouselElement) {
  import('./modules/vehicle-search-lift-carousel').then((vehicleSearchLiftCarousel) => vehicleSearchLiftCarousel.init());
}

const vehiclePage = document.querySelector('.vehicle-page');
if(vehiclePage) {
  import('./modules/tabbed-details').then((tabbedDetails) => tabbedDetails.default.init());
  import('./modules/funding-calculator').then((fundingCalculator) => fundingCalculator.default.init());
  import('./modules/page-view-indicator').then(indicator => indicator.default.init());
}

if(document.getElementsByClassName('hero-vehicle-search')) {
  import('./modules/analytics').then(analytics => analytics.default.heroVehicleSearchAnalytics());
}

if(document.getElementById('vehicle-search-watcher-form')) {
  import('./modules/analytics').then(analytics => analytics.default.searchWatcherAnalytics());
}

if(document.getElementById('extranet-reservation-list')) {
  import('./modules/extranet/reservations').then(res => res.default.init());
}

if(document.getElementById('vehicleTextSearchInput')) {
  import('./modules/vehicle-text-search');
}

//vehicle card fallback image if image fails to load (due to conversion que for example)
if(document.querySelector('.card')) {
  import('./modules/delegate-listener').then(m => {
    let imageErrors = 0;
    m.default('error', '.card__image img', event => {
      if(imageErrors > 12) return //prevent infinite looping if fallback image has issues
      event.delegateTarget.src = 'https://k-auto.studio.crasman.cloud/pub/system/img/placeholder.jpg?c=system_640x';
      imageErrors++;
    }, document.body, { capture: true });
  });
}

const seoContentElement = document.querySelector('.seo-content');
if(seoContentElement) {
  import('./modules/seo-content-accordion').then(Accordions => Accordions.init());
}

const vehicleReservationForm = document.querySelector('#reserve-or-buy-vehicle');
if(vehicleReservationForm) {
  import('./modules/vehicle-reservation-form').then(res => res.default.init());
}

const vehiclePageStickyCtaElement = document.querySelector('.vehicle-page-sticky-cta');
if (vehiclePageStickyCtaElement) {
  import('./modules/vehicle-page-sticky-cta').then(res => res.default.init());
}

const mapElement = document.getElementById('map');
if (mapElement) {
  import('./modules/map').then(map => map.init());
}
